(function () {
  angular
   .module('kareo.ui.shared.directives.validation.k-valid-email', [
     'kareo.ui.shared.modules.regex.email'
   ])
   .directive('kValidEmail', kValidEmail);

  kValidEmail.$inject = ['EMAIL_REGEX'];

  function kValidEmail(EMAIL_REGEX) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, atts, ngModel) {
        ngModel.$validators.email = function (modelValue) {
          ngModel.errorMessage = '';
          return ngModel.$isEmpty(modelValue) || EMAIL_REGEX.test(modelValue);
        };
      }
    };
  }
})();
